import React, {
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'

import {
  Form,
  Select,
} from 'antd'

import { filterProps } from '../forms/utils'

export const AntEditableCellContext = React.createContext(null)

const EditableSelectFormItem = ({ dataIndex, title, inputRef, onSave, options, ...props }) => (
  <Form.Item
    style={{
      margin: 0,
    }}
    name={dataIndex}
    rules={[
      {
        required: true,
        message: `${title} is required.`,
      },
    ]}
  >
    <Select
      placeholder="Select an option"
      showSearch
      options={options}
      ref={inputRef}
      onSelect={onSave}
      bordered={false}
      {...props}
      {...filterProps}
    />
  </Form.Item>
)

export const SelectEditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  options,
  selectProps,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false)
  const inputRef = useRef(null)
  const form = useContext(AntEditableCellContext)

  useEffect(() => {
    if (editing) {
      inputRef.current.focus()
    }
  }, [editing])

  const toggleEdit = () => {
    setEditing(!editing)

    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    })
  }

  const save = async () => {
    const values = await form.validateFields()

    handleSave({ ...record, ...values })

    toggleEdit()
  }

  let childNode = children

  if (editable) {
    childNode = editing ? (
      <EditableSelectFormItem
        dataIndex={dataIndex}
        title={title}
        inputRef={inputRef}
        onSave={save}
        options={options}
        {...selectProps}
      />
    ) : (
      <div className="editable-cell-value-wrap" onClick={toggleEdit}>
        {children}
      </div>
    )
  }

  return <td {...restProps}>{childNode}</td>
}
